import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function TambahBiaya() {
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [newData, setNewData] = useState({
    nama_biaya: "",
    biaya: "",
    deskripsi: "",
    updated_by: user.id,
  });
  const [biayaRp, setBiayaRp] = useState(0);
  const [isLoading, setIsLoading] = useState(false);


  // CONTROLLER
  const storeNewBiaya = () => {
    Swal.fire({
      title: 'Do you want to save new data?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Save',
      denyButtonText: `Don't save`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('new_data', JSON.stringify(newData));

        baseAPI
          .post(`/v1/csetting`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "New cost has been added.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil upload ${JSON.stringify(res)}`);
            setBiayaRp(0);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed add new cost.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
          })
      } else if (result.isDenied) {
        Swal.fire('New cost is not added', '', 'info')
      }
    });
  }
  
  const handleFormat = (biaya) => {
    const numericValue = biaya.replace(/[^0-9]/g, '');
    let rupiahPlafond = parseFloat(numericValue).toLocaleString('id-ID');
    setBiayaRp(rupiahPlafond);
    setNewData({...newData, biaya: numericValue});
  }

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Setting</Link> /{' '}
              <Link to='/setting/settingbiaya/tambahbiaya' style={{ color: '#333' }}>Tambah Biaya</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Tambah Biaya</b></p>
              </div>

              {/* Nama biaya */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Jenis Biaya
                </label>
                <input
                  className="form-control"
                  onChange={e => setNewData({...newData, nama_biaya: e.target.value})}
                />
              </div>

              {/* Biaya */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Biaya (Rp.)
                </label>
                <input
                  value={biayaRp === "NaN" ? "Rp.0" : "Rp." + biayaRp}
                  className="form-control"
                  onChange={e => handleFormat(e.target.value)}
                />
              </div>

              {/* Deskripsi */}
              <div className='col-md-12 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Deskripsi
                </label>
                <textarea
                  className="form-control"
                  onChange={e => setNewData({...newData, deskripsi: e.target.value})}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={newData.nama_biaya !== "" && newData.biaya !== "" && newData.deskripsi !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => storeNewBiaya()}
                >
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default TambahBiaya;